export const createPendingWriteQueue = () => {
  const pending = {};
  const timers = {};
  const inFlight = new Set();

  const startWrite = (write) => {
    const started = Promise.resolve(write());
    inFlight.add(started);
    started.finally(() => inFlight.delete(started));
    return started;
  };

  const enqueue = (key, write, delayMs) => {
    pending[key] = write;
    if (timers[key]) clearTimeout(timers[key]);
    timers[key] = setTimeout(() => {
      const fn = pending[key];
      delete pending[key];
      delete timers[key];
      if (fn) startWrite(fn);
    }, delayMs);
  };

  const flush = () => {
    const started = Object.keys(pending).map((key) => {
      if (timers[key]) {
        clearTimeout(timers[key]);
        delete timers[key];
      }
      const fn = pending[key];
      delete pending[key];
      return startWrite(fn);
    });
    return Promise.all([...started, ...inFlight]);
  };

  return { enqueue, flush };
};
